module.exports = __webpack_public_path__ + "img/car-19.b0ff6dae.jpg";